import { AlertTriangle, Phone } from "lucide-react";

/**
 * Bannière fixe d'urgence — UX réglementaire obligatoire sur toute page Q&A (CDC v1.0 §5)
 * "En cas d'urgence, appelez le 15 (SAMU)"
 */
export default function EmergencyBanner({ variant = "fixed" }) {
  if (variant === "inline") {
    return (
      <div className="bg-red-50 border border-red-200 text-red-900 rounded-xl px-4 py-3 flex items-start gap-3" data-testid="emergency-banner-inline" role="alert">
        <AlertTriangle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
        <div className="text-sm">
          <strong className="font-bold">En cas d'urgence vitale</strong>, appelez immédiatement le{" "}
          <a href="tel:15" className="font-extrabold underline decoration-2 underline-offset-2 hover:text-red-700">15 (SAMU)</a>
          {" "}ou le 112. Doctobook n'est pas un service d'urgence.
        </div>
      </div>
    );
  }
  // Fixed footer banner — always visible on Q&A pages
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bg-red-600 text-white shadow-lg" data-testid="emergency-banner" role="alert" aria-live="polite">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-sm">
        <Phone className="h-4 w-4 flex-shrink-0 animate-pulse" aria-hidden="true" />
        <span className="font-semibold">
          En cas d'urgence, appelez le{" "}
          <a href="tel:15" className="font-extrabold underline decoration-white decoration-2 underline-offset-2">15 (SAMU)</a>
          <span className="hidden sm:inline"> · Doctobook n'est pas un service d'urgence médicale</span>
        </span>
      </div>
    </div>
  );
}
